import React, { Component } from 'react'
import {Button,ButtonToolbar,FormControl,ControlLabel,InputGroup,FormGroup} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwsome from 'react-fontawesome'
import AutopartStore from '../../stores/AutopartStore'
import SWTWageItemListPopup from './SWTWageItemListModal'
// import SWTProgramPopup from './SWTProgramModal'
import AlertPopupStore from '../../component/element/AlertPopupStore'
import TextFieldModal from '../../component/element/TextFieldModal'

export default class SWTWageDataGrid extends Component {
  constructor(props) {
    super(...props)
    
    this.state = {data:this.newEmptyRow(10,1),options:[],showPopup:false,showProgram:false,program:null}

  }

  getWageList(){
    let {data} = this.state
    return data.reduce((rresult,item)=>{
      if(item.detail!==''){
        rresult.push(item)
      }
      return rresult
    },[])
  }

  setWageList(wageList){
    let data = wageList.map((item,index)=>{
      return {bfId:item.bf_work_damage_id,itemSeq:item.item_seq,rowNo:item.seq,itemcode:item.itemcode,detail:item.detail,quantity:item.quantity,pricePerUnit:item.price_per_unit,amount:item.amount,discountPercent:item.discount_percent,discountAmount:item.discount_amount}
    })
    if(data.length<=10){
      let itemSeq = data.length>0?data[data.length-1].itemSeq:1
      data = data.concat(this.newEmptyRow(10-data.length,itemSeq))
    }
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  newEmptyRow(number,itemSeq){
    //let {showQuantity}  = this.props.showQuantity
    //console.log('props',this.props)
    //let showQuantity = true    
    return new Array(number).fill(null).map((item,index)=>{
      itemSeq = (itemSeq*1 + 0.001).toFixed(3)
      return {bfId:'',rowNo:'',itemSeq:itemSeq,itemcode:'',detail:'',quantity:'',pricePerUnit:'',amount:'',discountPercent:'',discountAmount:''}
      
    })
  }

  onAddEmptyRowItemClick(){

  }

  onSearch(index,query){
    let {data} = this.state
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadWageItemList(-1,query,function(result){
      console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemcode,itemcode:item.itemcode,categoryName:item.category_name,detail:item.description,amount:item.price}
      })
      that.setState({options:options})
    })
    data[index]['detail'] = query
    data[index]['pricePerUnit'] = ''
    data[index]['discountPercent'] = ''
    data[index]['discountAmount'] = ''
    data[index]['quantity'] = 1
    
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  onSearch2(query){

    let that = this
    let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadWageSuggest(query,function(result){
      console.log(result)
      //that.setState({optins:result.data})
    })
    that.setState({optins:options})
  }

  // onPricePerUnitChange(index,e){
  //   let {data} = this.state
    
  //   let amount = e.target.value
  //   if(isNaN(amount)){
  //     data[index].pricePerUnit = ''
  //   }else{
  //     data[index].pricePerUnit = amount*1
  //   }
  //   data[index].amount = data[index].pricePerUnit*data[index].quantity

  //   console.log('row',index,e.target.value,data[index].amount,data[index].pricePerUnit,data[index].quantity)
  //   this.setState({data:data})
  // }

  // onQuantityChange(index,e){
  //   let {data} = this.state
  //   console.log('row',index,e)
  //   let amount = e.target.value
  //   if(isNaN(amount)){
  //     data[index].quantity = ''
  //   }else{
  //     data[index].quantity = amount
  //   }
  //   data[index].amount = data[index].pricePerUnit*data[index].quantity
  //   this.setState({data:data})
  // }


  onTypeaheadChange(index,option){
    // console.log('options',index,option)

    let {data} = this.state
    if(option.length===1){
      data[index].detail = option[0].detail
      if(typeof option[0].itemcode !=='undefined'){
        data[index].itemcode = option[0].itemcode      
        data[index].amount = option[0].amount
        data[index].pricePerUnit = option[0].amount
        data[index].quantity = 1
        
      }else{
        data[index].pricePerUnit = ''
        data[index].quantity = 1
      }
    }
    // else{
    //   data[index].detail = ''
    //   data[index].amount = ''
    //   data[index].itemcode = ''
    // }
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  onDetailInputChange(index,text){
    console.log('index',index,text)
  }

  onRemoveRowClick(delIndex){
    let {data} = this.state

    let itemSeq = data[delIndex].itemSeq
    data.splice(delIndex,1);

    let stop =false  
    let runNo = 0.001
    data = data.map((item,index)=>{
      if(index+1<data.length && Math.floor(item.itemSeq*1) !== Math.floor(data[index+1].itemSeq*1)){
        stop = true  
      }
      if(index >= delIndex  && !stop){
        if(index==delIndex){
          item.itemSeq =  itemSeq 
        }else{
          item.itemSeq = (itemSeq*1 + runNo).toFixed(3)          
          runNo += 0.001        
        }
        
      }
      return item
    })
    console.log('remove',delIndex,data)
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  onAddEmptyRowItemClick(number){
    let {data} = this.state

    let itemSeq = data.length>0?data[data.length-1].itemSeq:1
    let newRows = this.newEmptyRow(number,itemSeq)

    
    this.setState({data:data.concat(newRows)})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  onSearchClick(){
    this.refs.wageItemPopup.openPopup();
    this.setState({showPopup:true})
  }

  onProgramClick(){
      this.refs.programPopup.openPopup()
      this.setState({showProgram:true})
  }

  onItemSelect(newItem){
    //Finding Last row
    let {data} = this.state
    let foundItem = false
    data.map((item,index)=>{
      if(item.detail==='' && foundItem==false){
        item.itemcode = newItem.itemcode
        item.detail = newItem.description
        item.amount = newItem.price   
        item.pricePerUnit = newItem.price
        item.quantity = 1     
        foundItem = true
      }
    })

    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  // onProgramSelect(wageItem,partItem,program){
  //   let {data} = this.state
  //   // let popupStore = AlertPopupStore    

  //   // popupStore.confirm('มีรายการค่าแรงอยู่แล้ว ต้องการ',[{id:1,title:'ใส่ทับของเดิม'},{id:2,title:'ต่อรายการท้ายของเดิม'},{id:3,title:'กลับไปแก้ไข'}],function(id){

  //   // data = data.reduce(function(rresult,item) {
  //   //   if(item.detail!=='')
  //   //     rresult.push(item)
  //   //   return rresult
  //   // },[])     
  //   data = []
  //   // })
  //   let rowNo = data.length
  //   let newItems = wageItem.map((item,index)=>{
  //     rowNo++
  //     return {bfId:'',rowNo:rowNo,itemcode:item.wage_itemnum,detail:item.detail,pricePerUnit:item.wage_cost,quantity:item.quantity,amount:item.wage_cost}  
  //   })
  //   data = data.concat(newItems)    
  //   if(data.length<=10){
  //     let itemSeq = data.length>0?data[0].itemSeq:1
  //     data = data.concat(this.newEmptyRow(10-data.length,itemSeq))
  //   }    
  //   this.setState({data:data,program:program})
  //   if(typeof this.props.onProgramChange !=='undefined')
  //     this.props.onProgramChange(wageItem,partItem,program)
  // }

  onSeqClick(index){
    let {data} = this.state
    let fieldInfo = {title:'เปลี่ยนลำดับเป็น',showClear:true,index:index,value:'' }
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }

  onDamageSeqSave(fieldInfo){
    let {data} = this.state
    let itemSeq = fieldInfo.value*1

    if(fieldInfo.value===''){
      //Insert Empty Row
      let item = this.newEmptyRow(1,data[fieldInfo.index].itemSeq)[0]
      data.splice(fieldInfo.index+1, 0, item);    
      let stop =false  
      data = data.map((item,index)=>{
        if(index-1 > fieldInfo.index  && !stop){
          item.itemSeq = (item.itemSeq*1 + 0.001).toFixed(3)
          if(index+1<data.length && Math.floor(item.itemSeq*1) !== Math.floor(data[index+1].itemSeq*1)){
            stop = true  
          }
        }
        return item
      })
    }
    else if(fieldInfo.index==0&&fieldInfo.value=='0'){
      data = data.map((item,index)=>{
        item.itemSeq = index+1
        return item
      })
    }else{
      let runNo = 0.001
      data = data.map((item,index)=>{
        if(fieldInfo.index==index){          
          item.itemSeq = itemSeq
        }
        else if(index>fieldInfo.index){
          item.itemSeq = (itemSeq*1 + runNo).toFixed(3)          
          runNo += 0.001          
        }
        return item
      })
    }
    //console.log('data',fieldInfo,data)
    this.setState({data:data})
  }

  valueValid(value) {
    value = (value==''||value==null||value==undefined||isNaN(value)?0:value)
    return value
  }

  summaryAmount(){
    let {data} = this.state
    let sum = 0;
     data.map((item,index)=>{
        sum += this.valueValid(item.amount)*1
    })
    
    return (<span>{sum}</span>)
  }

  _renderMenuItemChildren(option, props, index) {
    if(option.amount>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} (หมวด{option.categoryName}) - {option.amount} บาท</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail}</span>
        </div>
      );
    }
  }

  renderQuantity(item,index){
    if(this.props.showQuantity){
    return [
      <td key={9991} className='text-right'>
        <FormControl className='text-center ' 
        value={item.quantity} 
        onChange={this.onTextChange.bind(this,index,'quantity')}/>                  
      </td>,
      <td key={9992} className='text-right'>
        <FormControl className='text-right' 
        value={item.pricePerUnit} 
        onChange={this.onTextChange.bind(this,index,'pricePerUnit')}/>                  
      </td>
    ]
    }else{
      return (
        <td className='text-right'>
          <FormControl className='text-right'  
          value={item.amount} 
          onChange={this.onTextChange.bind(this,index,'amount')}/>                  
        </td>
      )
    }
  }

  renderAmount(item){
    if(this.props.showQuantity){
      return (
        <td className='text-right'>
          <FormControl className='text-right'  value={item.amount} />                  
        </td>
      )
    }else{
      return ('')
    }
  }

  renderDiscountPercent(item,index){
    if(this.props.showDiscount){
      return (
        <td className='text-right'>
          <FormGroup>
            <InputGroup>
              <FormControl 
                style={{borderTopRightRadius:'4px',borderBottomRightRadius:'4px'}}
                type="text" 
                className='text-center'
                value={item.discountPercent}
                onChange={this.onTextChange.bind(this,index,'discountPercent')}
              />
              <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit'}}>%</InputGroup.Addon>
            </InputGroup>
          </FormGroup>           
        </td>
    )
    }else{
      return ('')
    }
  }

  renderDiscountAmount(item,index){ 
    if(this.props.showDiscount){
      return (
        <td className='text-right'>
          <FormControl 
            className='text-right' 
            value={item.discountAmount}
            onChange={this.onTextChange.bind(this,index,'discountAmount')}
          />      
        </td>
    )
    }else{
      return ('')
    }
  }

  renderSeq(itemSeq){
    let list = (itemSeq+"").split(".");
    let newSeq = itemSeq
    if(list.length==2){
      let digit = (list[1]+"").replace(/^0+/, '')
      newSeq = list[0]+"."+digit
    }
    return (<span>{newSeq}</span>)
  }

  renderRowData(){
    let {data,options} = this.state
    return data.map((item,index)=> { 
            // this.getAmount(item,index)
            return(           
              <tr key={index}>                
                <td className='text-center'>
                  <span >{index+1}</span>
                </td>
                <td>
                  <AsyncTypeahead
                    allowNew={true}
                    multiple={false}
                    newSelectionPrefix={'เพิ่มรายการใหม่ : '}   
                    promptText={'พิมพ์รายการเพื่อค้นหา...'}           
                    searchText={'กำลังค้นหา...'}
                    selected={[{detail:item.detail}]}
                    options={options}
                    labelKey="detail"
                    onSearch={this.onSearch.bind(this,index)}
                    onChange={this.onTypeaheadChange.bind(this,index)}
                    onInputChange={this.onDetailInputChange.bind(this,index)}
                    placeholder=""
                    renderMenuItemChildren={this._renderMenuItemChildren}
                  />                  
                </td>
                {this.renderQuantity(item,index)}       
                {this.renderDiscountPercent(item,index)}
                {this.renderDiscountAmount(item,index)}   
                {this.renderAmount(item)}                      
                <td>
                  <Button bsStyle={'danger'} bsSize={'sm'} onClick={this.onRemoveRowClick.bind(this,index)}><FontAwsome name="trash"/></Button>
                </td>
              </tr>
            )  
          }
        )
  }
  /*=================================*/
  // getAmount(item,index) {
  //   let {data} = this.state
  //   let discount = 0
  //   let amount = 0
  //   let price = 0
  //   price = item.pricePerUnit * item.quantity
  //   if (item.discountAmount<=0||isNaN(item.discountAmount)==true||item.discountAmount=="") {
  //     discount = 0
  //   } else {
  //     discount = item.discountAmount
  //   }  
  //   amount = price - discount
  //   if (amount==0||isNaN(amount)==true||amount==""){
  //     item.amount = 0
  //   } else {
  //     item.amount = amount
  //   }  
  // }

  getDiscountAmount(data,index) {
    
    if (data[index]['discountPercent']<=0||isNaN(data[index]['discountPercent'])==true){
      data[index]['discountAmount'] = 0
    } else {
      let discount = 0
      let price = 0
      price = data[index]['pricePerUnit'] * data[index]['quantity']
      discount = (price / 100) * data[index]['discountPercent']
      if (discount%1 != 0) {
        discount = discount.toFixed(2)
      }
      data[index]['discountAmount'] = discount
    }
    return data
  }

  getDiscountPercent(data,index) {
    
    if (data[index]['discountAmount']<=0||isNaN(data[index]['discountAmount'])==true){
      data[index]['discountPercent'] = 0
    } else {  
      let price = 0
      let discount = 0
      price = data[index]['pricePerUnit'] * data[index]['quantity']
      discount = (data[index]['discountAmount'] / price) * 100
      if (discount%1 != 0) {
        discount = discount.toFixed(2)
      }
      data[index]['discountPercent'] = discount
    }  
    return data
  }

  onTextChange(index,field,e){
    let {data} = this.state
    data[index][field] = e.target.value
    if(field==='pricePerUnit' || field==='quantity'){
      data[index].amount = (data[index].quantity*1) * (data[index].pricePerUnit*1)
    }else if(field=='amount'){
      if(!this.props.showQuantity){
        data[index]['pricePerUnit'] = data[index][field]
      }
    } else if (field=='discountAmount') {
      data = this.getDiscountPercent(data,index)
    } else if (field=='discountPercent') {
      data = this.getDiscountAmount(data,index)
    } else if (field=='quantity'||field=='pricePerUnit') {
      if ((e.target.value<=0||isNaN(e.target.value)==true||e.target.value=="")||(data[index].quantity<=0||isNaN(data[index].quantity)==true||data[index].quantity=="")||(data[index].pricePerUnit<=0||isNaN(data[index].pricePerUnit)==true||data[index].pricePerUnit=="")){
        data = this.getMistakeAmount(data,index)
      } else {          
        data = this.getDiscountAmount(data,index)
      }    
    } 

    if(this.props.showDiscount){
        let discount = 0
        let amount = 0
        let price = 0
        price = data[index].pricePerUnit * data[index].quantity
        if (data[index].discountAmount<=0||isNaN(data[index].discountAmount)==true||data[index].discountAmount=="") {
          discount = 0
        } else {
          discount = data[index].discountAmount
        }  
        amount = price - discount
        if (amount==0||isNaN(amount)==true||amount==""){
          data[index].amount = 0
        } else {
          data[index].amount = amount
        }      
    }

    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
    
  }

  getMistakeAmount(data,index) {
    
    data[index]['discountAmount'] = 0
    data[index]['amount'] = 0
    return data
  }
  /*=================================*/
  renderColumnQuantity(){
    if(this.props.showQuantity){
      return [
        <th key={1} style={{width:'70px'}} className='text-center'>จำนวน</th>,
        <th key={2} style={{width:'110px'}} className='text-center'>ราคาต่อหน่วย</th>,
      ]
    }else{
      return (
        <th style={{width:'110px'}} className='text-center'>ราคา</th>
      )
    }
  }

  renderColumnAmount(){
    if(this.props.showQuantity){
      return (
        <th style={{width:'110px'}} className='text-center'>รวมราคา</th>
      )
    }else{
      return ('')
    }
  }

  renderColumnDiscount(){
    if(this.props.showDiscount){
      return [
        <th key={1} style={{width:'80px'}} className='text-center'>ลด %</th>,
        <th key={2} style={{width:'110px'}} className='text-center'>ส่วนลด</th>,
      ]
    }else{
      return ('')
    }
  }

  renderTable(){
    let colSpan = this.props.showQuantity?4:2
    if(this.props.showDiscount){
      colSpan += 2
    }
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid' style={{minWidth:'1280px'}}>
          <thead>
            <tr>              
              <th style={{width:'50px'}}  className='text-center'>ลำดับ</th>
              <th className='text-center'>รายการ</th>
              {this.renderColumnQuantity()}    
              {this.renderColumnDiscount()}           
              {this.renderColumnAmount()}               
              <th style={{width:'50px'}} className='text-center'>ลบ</th>            
            </tr>          
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={colSpan} className='text-right'>รวมราคาค่าแรง (บาท)</th>            
              <th className='text-right'>{this.summaryAmount()}</th>
              <th></th>              
            </tr>
          </tfoot>
        </table>
      </div>  
    )
  }

  renderDocMenu(){
    return (
      <div className="margin box-tools pull-right">
        <div className="btn-group hide-when-done">
        <button type="button" className="btn btn-primary "><i className="fa  fa-edit"></i>&nbsp;สร้างเอกสาร</button>
        <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        <span className="caret"></span>
        <span className="sr-only">Toggle Dropdown</span>
        </button>
        <ul className="dropdown-menu" role="menu">
        <li aria-disabled="true"><a href="#new_doc_quotation"><i className="fa  fa-file-text-o text-green"></i>ใบเสนอราคา</a></li>
        <li aria-disabled="true"><a href="#new_doc_invoice"><i className="fa  fa-file-text-o text-green"></i>ใบแจ้งหนี้</a></li>
        <li aria-disabled="true"><a href="#new_doc_receipt"><i className="fa  fa-file-text-o text-green"></i>ใบเสร็จรับเงิน</a></li>
        <li aria-disabled="true"><a href="#new_doc_tax_invoice"><i className="fa  fa-file-text-o text-green"></i>ใบกำกับภาษี</a></li>
        <li aria-disabled="true"><a href="#new_doc_cash_bill"><i className="fa  fa-file-text-o text-green"></i>บิลเงินสด</a></li>
        <li aria-disabled="true"><a href="#new_doc_export_stock"><i className="fa  fa-file-text-o text-green"></i>ใบเบิกคลังสินค้า</a></li>
        </ul>
        </div>
      </div>
    )
  }

  render() {
    let {showPopup,showProgram,program} = this.state
    let {showProgramButton} = this.props
    
    return (
      <div >
       
          {this.renderTable()}
          <ButtonToolbar style={{display:'inline-block'}}>
            <Button bsStyle={null} className='bg-olive'           
              onClick={this.onAddEmptyRowItemClick.bind(this,1)}
            >
              +เพิ่มรายการ
            </Button>
            <Button bsStyle={null} className='bg-olive' 
              onClick={this.onAddEmptyRowItemClick.bind(this,10)}
            >
              +เพิ่ม 10 รายการ
            </Button>
            <Button bsStyle={'primary'} 
              onClick={this.onSearchClick.bind(this)}
            >
              <FontAwsome name='search'/>&nbsp;ค้นหาค่าแรง
            </Button>
            <Button bsStyle={'warning'} style={{display:(showProgramButton)?'':'none'}} 
              onClick={this.onProgramClick.bind(this)}
            >
              <FontAwsome name='book'/>&nbsp;เลือกโปรแกรม
            </Button> 
          </ButtonToolbar>
        <TextFieldModal ref='textFieldModal'
        confirmTitle='เปลี่ยน'
        deleteTitle='แทรกบรรทัด'
        onConfirm={this.onDamageSeqSave.bind(this)}
        onClear={this.onDamageSeqSave.bind(this)}
        />
        <SWTWageItemListPopup ref={'wageItemPopup'} show={showPopup} onSelect={this.onItemSelect.bind(this)} onHide={()=>{this.setState({showPopup:false})}}/>
        {/* <SWTProgramPopup ref={'programPopup'} show={showProgram} onSelect={this.onProgramSelect.bind(this)} onHide={()=>{this.setState({showProgram:false})}}/> */}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/view/workdoc/SWTWageDataGrid.js